import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { settingsQueryConfig } from '@webapp/core/query-configs/settings'
import {
  IntegrationStatus,
  type IntegrationStatusConstructor,
} from '@webapp/platform/integrations/entities/IntegrationStatus/IntegrationStatus'

export const useQuerySlackIntegrationConfig = () => {
  const { data, isLoading, error } = useQuery<IntegrationStatusConstructor>({
    ...settingsQueryConfig.getIntegrationStatus(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  const integrationStatus = useMemo(() => {
    return data ? new IntegrationStatus(data) : null
  }, [data])

  return {
    integrationStatus,
    isLoading,
    error: error as Error | null,
  }
}
